import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '@/lang'

import LoginView from '../views/Login/index.vue'
import HomeView from '../views/Home/index.vue'
import GameView from '../views/Game/index.vue'
import NewsView from '../views/News/index.vue'
import NewInfView from '../views/News/info.vue'
import ActiveView from '../views/Active/index.vue'
import ActiveInfoView from '../views/Active/info.vue'
import TaskView from '../views/Task/index.vue'
import MineView from '../views/Mine/index.vue'
import TurnoverView from '../views/Turnover/index.vue'
import AuthorizationView from '../views/Authorization/index.vue'
import VipView from '../views/VIP/index.vue'
import RechargeView from '../views/Recharge/index.vue'
import WithdrawView from '../views/Withdraw/index.vue'
import BankView from '../views/Bank/index.vue'
import AddBankView from '../views/Bank/add.vue'
import LoginErrorView from '../views/Authorization/error.vue'
import ChangePwdView from '../views/ChangePwd/index.vue'
import ProxyView from '../views/Proxy/index.vue'
import FanShuiRecordView from '../views/Proxy/fanshuirecord.vue'
import WaiShuiRecordView from '../views/Proxy/waishuirecord.vue'
import TeamInfoView from '../views/Proxy/teaminfo.vue'
import FindPwdView from '../views/ChangePwd/findpwd.vue'
import RegionRecordView from '../views/Proxy/regionrecord.vue'

// 活动临时
import TurntableView from '../views/Temporary/turntable.vue'  //转盘

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      title: i18n.t('menu.home'),
    }
    
  },
  {
    path: '/turntable',
    name: 'turntable',
    component: TurntableView,
    meta: {
      title: '幸运转盘',
    }
    
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: i18n.t('menu.home'),
    }
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    meta: {
      title: i18n.t('menu.home'),
    }
  },
  {
    path: '/game',
    name: 'game',
    component: GameView,
    meta: {
      title: i18n.t('menu.game'),
    }
  },
  {
    path: '/news',
    name: 'news',
    component: NewsView,
    meta: {
      title: i18n.t('menu.news'),
    }
  },
  {
    path: '/new',
    name: 'new',
    component: NewInfView,
    meta: {
      title: i18n.t('menu.news'),
    }
  },
  {
    path: '/active',
    name: 'active',
    component: ActiveView,
    meta: {
      title: i18n.t('menu.active'),
    }
  },
  {
    path: '/activeinfo',
    name: 'activeinfo',
    component: ActiveInfoView,
    meta: {
      title: i18n.t('menu.active'),
    }
  },
  {
    path: '/task',
    name: 'task',
    component: TaskView,
    meta: {
      title: i18n.t('menu.task'),
    }
  },
  {
    path: '/mine',
    name: 'mine',
    component: MineView,
    meta: {
      title: i18n.t('menu.mine'),
    }
  },
  {
    path: '/turnover',
    name: 'turnover',
    component:TurnoverView,
    meta: {
      title: i18n.t('menu.turnover'),
    }
  },
  {
    path: '/income',
    name: 'income',
    component:TurnoverView,
    meta: {
      title: i18n.t('menu.turnover'),
    }
  },
  {
    path: '/authorization',
    name: 'authorization',
    component:AuthorizationView,
    meta: {
      title: i18n.t('menu.authorization'),
    }
  },
  {
    path: '/vip',
    name: 'vip',
    component:VipView,
    meta: {
      title: i18n.t('menu.vip'),
    }
  },
  {
    path: '/recharge',
    name: 'recharge',
    component:RechargeView,
    meta: {
      title: i18n.t('menu.recharge'),
    }
  },
  {
    path: '/withdraw',
    name: 'withdraw',
    component:WithdrawView,
    meta: {
      title: i18n.t('menu.withdraw'),
    }
  },
  {
    path: '/bank',
    name: 'bank',
    component:BankView,
    meta: {
      title: i18n.t('menu.bank'),
    }
  },
  {
    path: '/addbank',
    name: 'addbank',
    component:AddBankView,
    meta: {
      title: i18n.t('menu.bank'),
    }
  },
  {
    path: '/error',
    name: 'error',
    component:LoginErrorView,
    meta: {
      title: i18n.t('menu.error'),
    }
  }, 
  {
    path: '/changepwd',
    name: 'changepwd',
    component:ChangePwdView,
    meta: {
      title: '支付密码',
    }
  }, 
  {
    path: '/findpwd',
    name: 'findpwd',
    component:FindPwdView,
    meta: {
      title: '找回支付密码',
    }
  }, 
  {
    path: '/proxy',
    name: 'proxy',
    component:ProxyView,
    meta: {
      title: '代理',
    }
  }, 
  {
    path: '/fsrecord',
    name: 'fsrecord',
    component:FanShuiRecordView,
    meta: {
      title: '返水领取记录',
    }
  }, 
  {
    path: '/wsrecord',
    name: 'wsrecord',
    component:WaiShuiRecordView,
    meta: {
      title: '外水领取记录',
    }
  }, 
  {
    path: '/team',
    name: 'team',
    component:TeamInfoView,
    meta: {
      title: '团队详情',
    }
  },
  {
    path: '/regionrecord',
    name: 'regionrecord',
    component:RegionRecordView,
    meta: {
      title: '大区返水记录',
    }
  }
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    // 核心配置：返回顶部坐标
    return new Promise((resolve) => {
      // 支持异步滚动 (如数据加载完成后)
      setTimeout(() => {
        resolve({ x: 0, y: 0, behavior: 'instant' })
      }, 50)
    })
  }
})

router.beforeEach((to, from, next) => {
  const nearestTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta?.title);
  if (to.params.id && nearestTitle) {
    document.title = `${nearestTitle.meta.title} `;
  } else {
    document.title = nearestTitle?.meta.title || '';
  }
  
  next();
});

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
